function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M315.424 229.882c0-36.096-29.261-65.357-65.357-65.357-26.635 0-49.535 15.94-59.715 38.796l-8.062 29.223 7.421 7.421-14.84 29.682 14.84 7.421-7.421 7.421v7.421l7.421 7.421v14.84l7.421 7.421 22.261-7.421s0 7.421 7.421 14.84c7.421 7.42 14.841 22.262 14.841 22.262s22.261 7.421 37.101-14.84 29.682-29.682 29.682-29.682l-14.305-28.61c13.08-11.951 21.291-29.143 21.291-48.259z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M320.751 254.876c30.152-5.087 35.176-64.13 35.176-64.13h-41.553c21.518 51.942-1.004 55.436-1.004 55.436-3.052-2.27-112.249-54-115.712-55.316-.834 1.116-3.903 4.047-7.635 13.174-3.732 9.127-4.649 17.338-4.649 17.338 1.749 1.139 117.718 41.633 120.783 41.971 6.083 3.978 13.569 15.871 9.385 51.137l39.996-11.273c-.002 0-13.575-36.109-34.787-48.337z",
  fill: "#acabb1"
});

const SvgCorsica = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCorsica, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/corsica.4b67a479.svg";
export { ForwardRef as ReactComponent };